import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { memoize } from 'lodash';
import { StyleSheet, keyframes, useToken, useStyles } from '@rexlabs/styling';
var animRotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
var getDashKeyframes = memoize(function (offset) {
  return keyframes({
    '0%': {
      strokeDashoffset: "".concat(offset - 1, "px"),
      transform: 'rotate(0deg)'
    },
    '50%': {
      strokeDashoffset: "".concat(offset / 4, "px"),
      transform: 'rotate(135deg)'
    },
    '100%': {
      strokeDashoffset: "".concat(offset - 1, "px"),
      transform: 'rotate(360deg)'
    }
  });
});
var getColorsKeyframe = memoize(function (colors) {
  var keyframeColors = _reduceInstanceProperty(colors).call(colors, function (allColors, color, i) {
    var percent = 0 + i * 100 / colors.length;
    return _objectSpread(_objectSpread({}, allColors), {}, _defineProperty({}, "".concat(percent, "%"), {
      stroke: color
    }));
  }, {});

  keyframeColors['100%'] = {
    stroke: colors[0]
  };
  return keyframes(keyframeColors);
}, function (colors) {
  return colors.join('|');
});
var defaultStyles = StyleSheet({
  svg: {
    animation: function animation(_ref) {
      var token = _ref.token;
      return "".concat(token('loadingSpinner.animation.rotate.keyframes', animRotate), " ") + "".concat(token('loadingSpinner.animation.duration', 1.4), "s linear infinite");
    }
  },
  circle: {
    strokeDasharray: function strokeDasharray(_ref2) {
      var token = _ref2.token;
      return "".concat(token('loadingSpinner.dash.offset', 187), "px");
    },
    transformOrigin: 'center'
  },
  spinner: {
    alignSelf: 'center',
    display: 'inline-flex'
  }
});
var defaultColors = ['grey'];

function LoadingSpinner(_ref3) {
  var _context, _context2;

  var propSize = _ref3.size,
      propStrokeWidth = _ref3.strokeWidth,
      propColors = _ref3.colors,
      Tag = _ref3.Tag,
      _ref3$as = _ref3.as,
      as = _ref3$as === void 0 ? 'div' : _ref3$as;
  var s = useStyles(defaultStyles, 'LoadingSpinner');
  var token = useToken();
  var Component = Tag || as;
  var size = propSize !== null && propSize !== void 0 ? propSize : token('loadingSpinner.size', 35);
  var strokeWidth = propStrokeWidth !== null && propStrokeWidth !== void 0 ? propStrokeWidth : token('loadingSpinner.strokeWidth', 6);
  var colors = propColors !== null && propColors !== void 0 ? propColors : token('loadingSpinner.colors', defaultColors);
  var animationDuration = token('loadingSpinner.animation.duration', 1.4);
  var offset = token('loadingSpinner.dash.offset', 187);
  var calcStrokeWidth = strokeWidth * (66 / size);

  var _useState = useState(getColorsKeyframe(colors)),
      _useState2 = _slicedToArray(_useState, 2),
      colorKeyframes = _useState2[0],
      setColorKeyframes = _useState2[1];

  useEffect(function () {
    setColorKeyframes(getColorsKeyframe(colors));
  }, [colors, setColorKeyframes]);

  var _useState3 = useState(token('loadingSpinner.animation.dash.keyframes', getDashKeyframes(offset))),
      _useState4 = _slicedToArray(_useState3, 2),
      dashKeyframes = _useState4[0],
      setDashKeyframes = _useState4[1];

  useEffect(function () {
    setDashKeyframes(token('loadingSpinner.animation.dash.keyframes', getDashKeyframes(offset)));
  }, [offset, setDashKeyframes, token]);
  return /*#__PURE__*/React.createElement(Component, s('spinner'), /*#__PURE__*/React.createElement("svg", _extends({}, s.with('svg')({
    transform: 'rotate(0deg)'
  }), {
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("circle", _extends({}, s.with('circle')({
    transform: 'rotate(0deg)'
  }), {
    style: {
      animation: _concatInstanceProperty(_context = "".concat(dashKeyframes, " ")).call(_context, animationDuration, "s ease-in-out infinite, ") + _concatInstanceProperty(_context2 = "".concat(colorKeyframes, " ")).call(_context2, animationDuration * colors.length, "s ") + "ease-in-out infinite"
    },
    fill: "none",
    strokeWidth: calcStrokeWidth,
    strokeLinecap: "round",
    cx: 33,
    cy: 33,
    r: 33 - calcStrokeWidth / 2
  }))));
}

export default LoadingSpinner;